"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterIndicatorWithClearButton = exports.filterIndicatorClearButtonTestId = exports.filterIndicatorMessageTestId = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var icons_1 = require("../../../gen-src/icons");
var LineageNavStyles_1 = require("./LineageNavStyles");
exports.filterIndicatorMessageTestId = 'filter-indicator-message-test-id';
exports.filterIndicatorClearButtonTestId = 'filter-indicator-clear-button-test-id';
var buttonDimensions = LineageNavStyles_1.lineageNavFilterIndicatorHeight - widgets_1.TabStyles.Sizing.BorderWidth * 2;
var filterTextMaxWidth = 150;
var filteredIndicatorClass = (0, data_catalog_shared_1.cssClass)('filteredIndicator', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    paddingLeft: widgets_1.TabStyles.Spacing.DefaultSpace,
    border: "".concat(widgets_1.TabStyles.Sizing.BorderWidth, "px solid ").concat(widgets_1.TabStyles.Colors.F5),
    boxSizing: 'border-box',
    height: LineageNavStyles_1.lineageNavFilterIndicatorHeight,
    lineHeight: "".concat(LineageNavStyles_1.lineageNavFilterIndicatorHeight, "px"),
    alignItems: 'center',
});
var clearButtonStyle = {
    padding: 0,
    marginLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    minHeight: buttonDimensions,
    minWidth: buttonDimensions,
    height: buttonDimensions,
    width: buttonDimensions // for IE
};
var filteredItemTextClass = (0, data_catalog_shared_1.cssClass)('filteredItemText', __assign(__assign({}, data_catalog_shared_1.elideTextStyle), { maxWidth: filterTextMaxWidth }));
function FilterIndicatorWithClearButton(props) {
    return (react_1.default.createElement(data_catalog_shared_1.HorizontalFlexContainer, { additionalClassNames: [filteredIndicatorClass] },
        react_1.default.createElement("span", { className: filteredItemTextClass, "data-tb-test-id": exports.filterIndicatorMessageTestId, title: props.filteredItemName }, Localize_1.Messages.Filter({ filteredItemName: props.filteredItemName })),
        react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Icon, handleClick: props.clearFilters, title: Localize_1.Messages.ClearFilter(), testId: exports.filterIndicatorClearButtonTestId, style: clearButtonStyle, getContent: function () { return (react_1.default.createElement(icons_1.SvgCloseButton, null)); } })));
}
exports.FilterIndicatorWithClearButton = FilterIndicatorWithClearButton;
//# sourceMappingURL=FilterIndicatorWithClearButton.js.map